export enum EmbeddedSubtitleType {
    Subtitle = 1,
    CleanVideo = 2
}
